import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { CoreModule, StoreService } from './core';
import { SharedModule } from './shared';
//import { PdfViewerModule } from 'ng2-pdf-viewer';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CheckDateValidityPipe } from './shared/pipe/check-date-validity.pipe';
import { WinnerspageComponent } from './winnerspage/winnerspage.component';
import { AcknowldgementDialogComponent } from './acknowldgement-dialog/acknowldgement-dialog.component';
import { ComingSoonComponent } from './coming-soon/coming-soon.component';



// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}



@NgModule({
  declarations: [
    AppComponent,
    CheckDateValidityPipe,
    WinnerspageComponent,
    AcknowldgementDialogComponent,
    ComingSoonComponent
  ],
  imports: [
    BrowserModule.withServerTransition({appId: 'my-app'}),
    CoreModule,
    SharedModule,
    AppRoutingModule, 

    //PdfViewerModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
